import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import Loading from '../Loading';
import useAccesoEvento from './useAccesoEvento';

const ProtectedLayout = ({ children, allowedRoles }) => {
  const { id } = useParams();
  const { cargando, permitido } = useAccesoEvento(id, allowedRoles);

  if (cargando) return <Loading />;
  if (!permitido) return <Redirect to="/unauthorized" />;
  return <>{children}</>;
};

export default ProtectedLayout;
